import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import utils from '../utils/utils';
import { Link, withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList } from '@fortawesome/free-solid-svg-icons';
import apiCalls from '../utils/apiCalls';

const MarketplaceAdminItemCollectionsIndex = ({ itemCollections, match, intl, getItemCollections }) => {
  function deleteItemCollection(itemCollection) {
    const confirmMessage = intl.formatMessage({ id: 'marketplace.admin.item.collections.delete.confirm' });

    if (window.confirm(confirmMessage)) {
      apiCalls
        .deleteItemCollection(itemCollection.id)
        .then(() => {
          getItemCollections();
        })
        .catch((errors) => {
          window.alert(utils.getErrorMessageFromResponse(errors, true));
        });
    }
  }

  const { formatMessage } = useIntl();

  return (
    <div className="panel">
      <div className="panel__corner">
        <FontAwesomeIcon icon={faList} />
      </div>
      <h6 className="panel__title">
        <FormattedMessage id={'marketplace.admin.item.collections.header'} />
      </h6>

      <p className="m-b-6">
        <FormattedMessage id={'marketplace.admin.item.collections.description'} />
      </p>

      <div className="m-b-6">
        <Link className="btn btn-primary" to={`${match.url}/create`}>
          <FormattedMessage id={'marketplace.admin.item.collections.create'} />
        </Link>
      </div>

      <table className="table table-striped admin__table">
        <thead>
          <tr>
            <th scope="col">
              <FormattedMessage id={'marketplace.admin.item.collections.table.id'} />
            </th>
            <th scope="col">
              <FormattedMessage id={'marketplace.admin.item.collections.table.name'} />
            </th>
            <th scope="col">
              <FormattedMessage id={'marketplace.admin.item.collections.table.items'} />
            </th>
            <th scope="col">
              <FormattedMessage id={'marketplace.admin.item.collections.table.actions'} />
            </th>
          </tr>
        </thead>
        <tbody>
          {itemCollections.map((itemCollection, itemIndex) => {
            return (
              <tr key={itemIndex}>
                <th scope="row">#{itemCollection.id}</th>
                <td>{itemCollection.name}</td>
                <td>
                  {itemCollection.items.map((item, index) => {
                    return (
                      <div key={index} className="">
                        #{item.id} - {utils.getItemName(item, formatMessage)}
                      </div>
                    );
                  })}
                </td>
                <td>
                  <Link className="link" to={`${match.url}/edit/${itemCollection.id}`}>
                    <FormattedMessage id={'marketplace.admin.item.collections.table.actions.edit'} />
                  </Link>
                  <br />
                  <button className="btn btn-normal-link" onClick={() => deleteItemCollection(itemCollection)}>
                    Delete
                  </button>
                  <br />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

MarketplaceAdminItemCollectionsIndex.propTypes = {
  itemCollections: PropTypes.array.isRequired,
  getItemCollections: PropTypes.func.isRequired,
};

MarketplaceAdminItemCollectionsIndex.defaultProps = {};

export default injectIntl(withRouter(MarketplaceAdminItemCollectionsIndex));
